<script>
    import MediaImage from '../../../../resources/js/components/MediaImage.vue';
    import { handleScoopAjaxError } from '../../../../resources/js/mixins/axios-response-errors'

    export default {
        components: {
            'media-image': MediaImage,
        },
        model: {
            prop: 'package',
            event: 'set-package'
        },
        props: {
            package: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                changingPackageName: false,
                selectedMediaData: [],
            }
        },
        computed: {
            selectedMediaIds: {
                get: function () {
                    return scoopOS.getSelected('medias');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('medias', newValue);
                }
            },
            contentMediaIds() {
                return _.map(this.package.contents, packagecontent => {
                    return packagecontent.content.id;
                });
            },
            selectedButMissingImageIds() {
                return _.difference(this.selectedMediaIds, this.contentMediaIds);
            },
            packageName: {
                get() {
                    if (this.package.package_name) {
                        return this.package.package_name;
                    }

                    return __('scoop-os.packages.default_package_name', {'id': this.package.id});
                },
                set(newValue) {
                    this.$emit('set-package', _.merge(this.package, {
                        package_name: newValue,
                        packageNameShort: _.truncate(newValue, {'length': 30, 'separator': '...'}),
                    }));
                }
            }
        },
        methods: {
            add() {
                axios.post(Scoop.baseUrl + `/mediaserver/packages/${this.package.id}/content`)
                    .then(response => {
                        toastr.info('Media has been added');
                        this.$emit('set-package', response.data);
                    })
                    .catch(error => handleScoopAjaxError(error, 'Media could not be added'));
            },
            remove(packagecontent) {
                axios.delete(Scoop.baseUrl + `/mediaserver/packages/${packagecontent.package_id}/content/${packagecontent.id}`)
                    .then(response => {
                        toastr.info('Media has been removed');
                        this.$emit('set-package', response.data);
                    })
                    .catch(error => handleScoopAjaxError(error, 'Media could not be removed'));
            },
            updatePackage() {
                axios.patch(Scoop.baseUrl + `/mediaserver/packages/${this.package.id}`, this.package)
                    .then(response => toastr.info('Package has been updated'))
                    .catch(error => handleScoopAjaxError(error, 'Package could not be updated'));

                this.changingPackageName = false;
            }
        },
    }
</script>
<template>
    <span class="media-package-content">

            <Lightbox
                    :id="'media-package-content-'+package.id"
                    headline="Package contents"
                    :large="true"
            >
                <span slot="open-template">
                    <slot name="opener"></slot>
                </span>
                <span slot="subheadline">
                    <small class="font-bold">
                        <template v-if="changingPackageName">
                            <input v-model="packageName" @keyup.enter="updatePackage" type="text" class="input-s">
                            <a @click="updatePackage">Save</a>
                        </template>
                        <template v-if="!changingPackageName">
                            {{ packageName }}
                            <a v-if="package.current_user_is_admin" @click="changingPackageName = true">Change</a>
                        </template>
                    </small>

                </span>
                <div slot="body" class="text-left">
                    <div class="row">

                        <div v-if="package.current_user_is_admin && selectedButMissingImageIds.length">
                            <div class="alert alert-info">
                                <div class="text-muted m-b-xs" v-html="__('scoop-os.packages.contents.select_media_to_add_to_package_info')"></div>
                                <a @click="add()" class="btn btn-primary" v-text="__('scoop-os.packages.contents.select_media_to_add_to_package', { count: selectedButMissingImageIds.length})"></a>
                            </div>
                        </div>

                        <media-image
                                v-for="packagecontent in package.contents"
                                :key="packagecontent.content.id"
                                :media="packagecontent.content"
                                :link-to-detail="false"
                                class="file-box"
                        >
                            <template slot="icons">
                                <span v-if="packagecontent.content.failed_validations && packagecontent.content.failed_validations.length"
                                      class="label inside label-warning m-xs">
                                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                </span>
                                <span v-if="packagecontent.content.clipped_images && packagecontent.content.clipped_images.length"
                                      class="label inside label-warning m-xs">
                                    <i class="fa fa-crop" aria-hidden="true"></i>
                                </span>
                                <a v-if="package.current_user_is_admin" @click="remove(packagecontent)">
                                    <span class="label inside label-danger pull-right m-xs">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </span>
                                </a>
                            </template>
                        </media-image>
                    </div>
                </div>
                <div v-cloak slot="footer">
                    <button type="button" class="btn btn-white" data-dismiss="modal" v-text="__('scoop-os.common.close')"></button>
                </div>
            </Lightbox>
    </span>
</template>
